import { render, staticRenderFns } from "./SocksProxies.vue?vue&type=template&id=9ebe3ece&scoped=true"
import script from "./SocksProxies.vue?vue&type=script&lang=js"
export * from "./SocksProxies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ebe3ece",
  null
  
)

export default component.exports